<template>
  <div id="wrapper" class="clearfix">
    <div id="preview">
      <component v-for="(block, i) in AppState.currentPage.blocks" :key="block.blockID" :is="block.template" :block="block" :order="i" @deleteBlock="deleteBlock(block)" @moveBlock="moveBlock($event, block)"></component>
    </div>

    <!-- Back To Top -->
    <a href="javascript:void(0);" class="s-back-to-top js__back-to-top"></a>

    <!-- SETTINGS POPUP -->
    <v-dialog v-if="AppState.showSettings" v-model="publishOpen" lazy max-width="800px" scrollable persistent>
      <v-card>
        <v-card-title> <span class="headline">Publish Page</span> </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field box multi-line label="Export HTML" :value="exportHtml" ref="txtExportHTML"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <button @click="copyClipboard">Copy to clipboard</button>
                <span v-text="copyMsg" class="pl-4 green--text darken-1"></span>
              </v-flex>
              <v-flex xs6>
                <button @click="downloadHtml">Download as HTML</button>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.stop.prevent="popPublishClose">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- SETTINS POPUP -->
  </div>
</template>

<script>
import Pretty from "pretty";
import DownloadJs from "downloadjs";
import { dbPages } from "../firebase";
import AppState from "../util/AppState";
import bus from "../util/bus";

export default {
  components: {
    // "block-nav": () => import("../blocks/BlockNav"),
    "block-header1": () => import("../blocks/BlockHeader1"),
    "block-header2": () => import("../blocks/BlockHeader2"),
    "block-parallax1": () => import("../blocks/BlockParallax1"),
    "block-features1": () => import("../blocks/BlockFeatures1"),
    "block-info1": () => import("../blocks/BlockInfo1")
    // "block-stats": () => import("../blocks/BlockStats"),
    // "block-contact": () => import("../blocks/BlockContact")
  },
  data() {
    return {
      publishOpen: false,
      exportHtml: "",
      copyMsg: "",
      AppState
    };
  },
  created() {
    bus.$on("publish", () => {
      AppState.loading = true;
      AppState.showSettings = false;
      this.exportHtml = "";
      bus.$emit("prePublish");
      // Wait for editor cleanup
      this.$nextTick(() => {
        this.exportHtml = this.$el.ownerDocument.documentElement.innerHTML
          .replace(/&quot;/g, "'")
          // .replace(/"\/static\//g, '"static/')
          .replace(
            `<link type="text/css" rel="stylesheet" media="all" href="${AppState.baseURL}/static/templates/_preview.css">`,
            ""
          )
          .replace(
            '<link type="text/css" rel="stylesheet" media="all" href="https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/medium-editor.min.css">',
            ""
          )
          .replace(
            '<link type="text/css" rel="stylesheet" media="all" href="https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/themes/flat.css">',
            ""
          );
        this.exportHtml = Pretty(
          `<!DOCTYPE html><html>${this.exportHtml}</html>`,
          { ocd: true }
        );
        bus.$emit("postPublish");
        AppState.showSettings = true;
        this.publishOpen = true;
        AppState.loading = false;
      });
    });
    bus.$on("saveTemp", () => {
      const p = AppState.currentPage;
      dbPages.doc(p.id).update({
        blockID: p.blockID,
        blocks: JSON.stringify(p.blocks)
      });
    });
    bus.$on("loadTemp", () => {});
  },
  mounted() {
    this.doc = this.$el.ownerDocument;
    this.win = this.doc.defaultView;
    bus.$on("addedBlock", bl => {
      this.$nextTick(() => {
        this.doc.body.scrollTop =
          bl.type === "nav" ? 0 : this.doc.body.scrollHeight;
      });
    });
  },
  methods: {
    popPublishClose() {
      this.publishOpen = false;
    },
    deleteBlock(block) {
      AppState.currentPage.blocks = AppState.currentPage.blocks.filter(
        el => el.blockID !== block.blockID
      );
    },
    moveBlock(params, block) {
      let index = 0;
      const blockList = AppState.currentPage.blocks;
      blockList.forEach((el, ind) => {
        if (el.blockID === block.blockID) {
          index = ind;
        }
      });
      const movedBlock = blockList.splice(index, 1)[0];
      blockList.splice(index + params.dir, 0, movedBlock);
      this.$nextTick(() => {
        params.el.scrollIntoView({ behavior: "smooth" });
      });
    },
    copyClipboard() {
      if (this.$clipboard(this.exportHtml)) {
        this.$refs.txtExportHTML.$el.querySelector("textarea").select();
        this.copyMsg = "Copied to clipboard!";
      } else {
        this.$refs.txtExportHTML.$el.querySelector("textarea").select();
        this.copyMsg = "Press Ctrl+c to copy!";
      }
      setTimeout(() => {
        this.copyMsg = "";
      }, 3000);
    },
    downloadHtml() {
      // TODO: name the file from the page. And on page settings have title and filename.
      DownloadJs(this.exportHtml, "index.html", "text/html");
    }
  }
};
</script>

<style>
.popSettings_image {
  display: block;
  position: relative;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue